if (!customElements.get('hero-carousel')) {
  class HeroCarousel extends HTMLElement {
    connectedCallback() {
      this.swiperEl = this.querySelector('.hero-carousel__swiper');
      if (!this.swiperEl || typeof Swiper === 'undefined') return;

      this.slides = this.swiperEl.querySelectorAll('.swiper-slide');
      this.prevEl = this.querySelector('.hero-carousel__arrow--prev');
      this.nextEl = this.querySelector('.hero-carousel__arrow--next');
      this.paginationEl = this.querySelector('.hero-carousel__dots');

      const autoplayEnabled = this.dataset.autoplay === 'true';
      const speed = (parseInt(this.dataset.speed, 10) || 5) * 1000;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const hasMultipleSlides = this.slides.length > 1;

      this.swiper = new Swiper(this.swiperEl, {
        effect: 'fade',
        fadeEffect: { crossFade: true },
        speed: 700,
        loop: hasMultipleSlides,
        allowTouchMove: hasMultipleSlides,
        autoplay: (autoplayEnabled && !reducedMotion && hasMultipleSlides)
          ? { delay: speed, disableOnInteraction: false, pauseOnMouseEnter: true }
          : false,
        navigation: (this.prevEl && this.nextEl && hasMultipleSlides)
          ? { prevEl: this.prevEl, nextEl: this.nextEl }
          : false,
        pagination: (this.paginationEl && hasMultipleSlides)
          ? { el: this.paginationEl, clickable: true }
          : false,
        a11y: { enabled: true },
      });

      document.addEventListener('shopify:section:load', this.handleSectionLoad = (event) => {
        if (event.target.contains(this) && this.swiper) {
          this.swiper.update();
        }
      });

      document.addEventListener('shopify:block:select', this.handleBlockSelect = (event) => {
        if (!this.swiper) return;
        const slideEls = Array.from(this.slides);
        const slide = slideEls.find((el) => el.contains(event.target) || el === event.target);
        if (!slide) return;
        const index = slideEls.indexOf(slide);
        if (index === -1) return;
        if (this.swiper.autoplay) this.swiper.autoplay.stop();
        this.swiper.slideToLoop(index);
      });

      document.addEventListener('shopify:block:deselect', this.handleBlockDeselect = () => {
        if (this.swiper && this.swiper.autoplay && autoplayEnabled && !reducedMotion) {
          this.swiper.autoplay.start();
        }
      });
    }

    disconnectedCallback() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
      if (this.handleSectionLoad) document.removeEventListener('shopify:section:load', this.handleSectionLoad);
      if (this.handleBlockSelect) document.removeEventListener('shopify:block:select', this.handleBlockSelect);
      if (this.handleBlockDeselect) document.removeEventListener('shopify:block:deselect', this.handleBlockDeselect);
    }
  }

  customElements.define('hero-carousel', HeroCarousel);
}
